import { useState } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: max-content;
	width: 100%;
	border: 1px solid rgba(45, 35, 66, 0.1);
	border-radius: 10px;
	overflow:hidden;
`;

const AccordianHeader = styled.div`
	padding: 0.5rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	border-radius: ${(props) => (props.isActive ? "10px 10px 0 0" : "10px")};
	transition:200ms all linear;
	height: max-content;
	background: ${(props) => {
		if(props.background) return props.background;
		if(props.isActive) return "rgba(45, 35, 66, 0.1)"
	}};
`;

const AccordianHeadText = styled.div`
	width: max-content;
	font-size: 18px;
	font-weight: 600;
	color: ${(props) => (props.isActive ? "" : "")};
`;

const AccordianChildren = styled.div`
	width: 100%;
	height: max-content;
	background:#FFF;
	max-height: ${(props) => (props.isActive ? "800px" : "0")};
	opacity: ${(props) => (props.isActive ? "1" : "0")};
	overflow: hidden;
	transition: 200ms max-height ease-in-out, 200ms opacity linear;
`;

const Accordian = (props) => {
	const { header, children, headerBackground, alwaysActive = false, activeInitially } = props;
	const initalActiveValue = () => {
		if (alwaysActive || activeInitially) return true;
		return false;
	};
	const [isActive, toggleActive] = useState(initalActiveValue);
	return (
		<Wrapper>
			<AccordianHeader
				background={headerBackground}
				isActive={isActive}
				onClick={() => {
					if (alwaysActive) return;
					toggleActive((prev) => !prev);
				}}>
				<AccordianHeadText isActive={isActive}>{header}</AccordianHeadText>
				<div className={isActive ? "rotate-up" : "rotate-down"}>
					<span
						color={isActive ? "#FFF" : ""}
						className="material-symbols-outlined">
						expand_more
					</span>
				</div>
			</AccordianHeader>
			<AccordianChildren isActive={isActive}>{children}</AccordianChildren>
		</Wrapper>
	);
};

export default Accordian;
